import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { AlertMessageService } from '../../services/alert-message/alert-message.service';
import { TAlert } from '../../types';
import { StringifyAndParse } from '../../utils/string';
import { TableData } from './table.types';
import { PaginationData } from '../pagination/pagination.types';

@Component({
  selector: 'cohrex-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TableComponent implements OnChanges {
  private _data?: TableData;
  @Input()
  set data(value: TableData | undefined) {
    this._data = value;
  }
  get data(): TableData | undefined {
    return this._data;
  }

  private _actionTemplate?: TemplateRef<any>;
  @Input()
  set actionTemplate(value: TemplateRef<any> | undefined) {
    this._actionTemplate = value;
  }
  get actionTemplate(): TemplateRef<any> | undefined {
    return this._actionTemplate;
  }

  private _alertMessage?: TAlert;
  @Input()
  set alertMessage(value: TAlert | undefined) {
    this._alertMessage = value;
  }
  get alertMessage(): TAlert | undefined {
    return this._alertMessage;
  }

  private _paginationData?: PaginationData | undefined;
  @Input()
  set paginationData(value: PaginationData | undefined) {
    this._paginationData = value;
  }
  get paginationData(): PaginationData | undefined {
    return this._paginationData;
  }

  private _loading?: boolean;
  @Input()
  set loading(value: boolean | undefined) {
    this._loading = value;
  }
  get loading(): boolean | undefined {
    return this._loading;
  }

  @Input() resource: string = 'data';
  @Input() canCreate: boolean = true;
  sortType: string = 'desc';

  @Output()
  addResource: EventEmitter<void> = new EventEmitter();
  @Output()
  pageChanged: EventEmitter<number> = new EventEmitter();

  translatedResource = { resource: this.resource };

  private stringifyObject = JSON.stringify;

  constructor(private alertMessageService: AlertMessageService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.translatedResource = { resource: this.resource };
    const tableActions = document.querySelectorAll('.tableActions');
    if (tableActions.length > 0) {
    }
  }

  handleAlertClosed() {
    this.alertMessage = StringifyAndParse({
      ...this.alertMessage,
      visible: false
    });
  }

  handlePageChanged(page: number): void {
    this.pageChanged.emit(page);
  }

  sortColumn(columnId: string) {
    if (this.data) {
      const tableItems = StringifyAndParse(this.data?.items ?? []) as any[];
      tableItems.sort((a, b) => {
        const bValue =
          (typeof b[columnId] !== 'string'
            ? b[columnId]?.value
            : b[columnId]) ?? '';
        const aValue =
          (typeof a[columnId] !== 'string'
            ? a[columnId]?.value
            : a[columnId]) ?? '';
        const firstValue =
          this.sortType === 'desc'
            ? bValue.toLowerCase()
            : aValue.toLowerCase();
        const secondValue =
          this.sortType === 'desc'
            ? aValue.toLowerCase()
            : bValue.toLowerCase();
        return firstValue.localeCompare(secondValue);
      });
      this.data.items = tableItems;
    }
    this.sortType = this.sortType === 'desc' ? 'asc' : 'desc';
  }
}
